import { Label, Popup } from 'semantic-ui-react';
import { MARKETPLACE_STATUSES } from 'constants/constants';
import DateColumn from 'components/DateColumn/DateColumn';

export const getColumns = (renderActions = () => {}) => [
  {
    Header: 'ID Vendor',
    disableSortBy: true,
    accessor: 'purchase_number',
    width: 150,
  },
  {
    Header: 'ID B2B',
    disableSortBy: true,
    accessor: 'b2b_id',
    width: 120,
    textAlign: 'center',
  },
  {
    Header: 'Se envía el',
    disableSortBy: true,
    accessor: 'ship_date',
    width: 120,
    Cell: ({ value }) => <DateColumn date={value} format="dd-MM-yyyy" />,
  },
  {
    Header: 'Error',
    disableSortBy: true,
    accessor: 'error',
    width: 150,
    Cell: ({ value }) => (
      <Popup
        className="base-tooltip"
        content={value}
        trigger={
          <div className="retry-shipments-table__error-column">{value}</div>
        }
      />
    ),
  },
  {
    Header: 'Estado',
    disableSortBy: true,
    accessor: 'status',
    width: 160,
    Cell: ({ value }) => (
      <Label color={MARKETPLACE_STATUSES[value]?.color || 'brown'}>
        {MARKETPLACE_STATUSES[value]?.text || value}
      </Label>
    ),
  },
  {
    Header: 'Detalles',
    disableSortBy: true,
    textAlign: 'right',
    width: 100,
    Cell: ({ row }) => {
      return renderActions(row.original);
    },
  },
];
